import {
    SET_FILTERS_MODAL,
    GET_ALL_FILTERS_BEGIN, GET_ALL_FILTERS_SUCCESS, GET_ALL_FILTERS_FAILURE,
    GET_FILTER_BEGIN, GET_FILTER_SUCCESS, GET_FILTER_FAILURE,
    POST_FILTER_BEGIN, POST_FILTER_SUCCESS, POST_FILTER_FAILURE,
    PUT_FILTER_BEGIN, PUT_FILTER_SUCCESS, PUT_FILTER_FAILURE,
    DELETE_FILTER_BEGIN, DELETE_FILTER_SUCCESS, DELETE_FILTER_FAILURE,
    GET_FILTERED_USERS_BEGIN, GET_FILTERED_USERS_SUCCESS, GET_FILTERED_USERS_FAILURE
} from '../constants/ActionTypes'

const initialState = {
    currentFiltersModal: null,

    filters: null,
    filtersError: null,
    loadingFilters: false,

    selectedFilter: null,
    getFilterError: null,
    gettingFilter: false,

    createFilterError: null,
    creatingFilter: false,

    editFilterError: null,
    editingFilter: false,

    deleteFilterError: null,
    deletingFilter: false,

    filteredUsers: null,
    filteredUsersError: null,
    loadingFilteredUsers: false,
}

const ReducerFilter = (state = initialState, { payload, type }) => {

    switch (type) {

        case SET_FILTERS_MODAL: {
            return {
                ...state,
                currentFiltersModal: payload
            }
        }

        case GET_ALL_FILTERS_BEGIN: {
            return {
                ...state,
                filters: null,
                filtersError: null,
                loadingFilters: true
            }
        }

        case GET_ALL_FILTERS_SUCCESS: {
            return {
                ...state,
                filters: payload.response,
                filtersError: null,
                loadingFilters: false
            }
        }

        case GET_ALL_FILTERS_FAILURE: {
            return {
                ...state,
                filters: null,
                filtersError: payload,
                loadingFilters: false
            }
        }

        case GET_FILTER_BEGIN: {
            return {
                ...state,
                selectedFilter: null,
                getFilterError: null,
                gettingFilter: true
            }
        }

        case GET_FILTER_SUCCESS: {
            return {
                ...state,
                selectedFilter: payload.response,
                getFilterError: null,
                gettingFilter: false
            }
        }

        case GET_FILTER_FAILURE: {
            return {
                ...state,
                selectedFilter: null,
                getFilterError: payload,
                gettingFilter: false
            }
        }

        case POST_FILTER_BEGIN: {
            return {
                ...state,
                createFilterError: null,
                creatingFilter: true
            }
        }

        case POST_FILTER_SUCCESS: {
            return {
                ...state,
                createFilterError: null,
                creatingFilter: false
            }
        }

        case POST_FILTER_FAILURE: {
            return {
                ...state,
                createFilterError: payload,
                creatingFilter: false
            }
        }

        case PUT_FILTER_BEGIN: {
            return {
                ...state,
                editFilterError: null,
                editingFilter: true
            }
        }

        case PUT_FILTER_SUCCESS: {
            return {
                ...state,
                editFilterError: null,
                editingFilter: false
            }
        }

        case PUT_FILTER_FAILURE: {
            return {
                ...state,
                editFilterError: payload,
                editingFilter: false
            }
        }

        case DELETE_FILTER_BEGIN: {
            return {
                ...state,
                deleteFilterError: null,
                deletingFilter: true
            }
        }

        case DELETE_FILTER_SUCCESS: {
            return {
                ...state,
                deleteFilterError: null,
                deletingFilter: false
            }
        }

        case DELETE_FILTER_FAILURE: {
            return {
                ...state,
                deleteFilterError: payload,
                deletingFilter: false
            }
        }

        case GET_FILTERED_USERS_BEGIN: {
            return {
                ...state,
                filteredUsers: null,
                filteredUsersError: null,
                loadingFilteredUsers: true
            }
        }

        case GET_FILTERED_USERS_SUCCESS: {
            return {
                ...state,
                filteredUsers: payload.response,
                filteredUsersError: null,
                loadingFilteredUsers: false
            }
        }

        case GET_FILTERED_USERS_FAILURE: {
            return {
                ...state,
                filteredUsers: null,
                filteredUsersError: payload,
                loadingFilteredUsers: false
            }
        }

        default: return state

    }

}

export default ReducerFilter